module.exports = __webpack_public_path__ + "img/male.7f4ab7ff.png";